import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';

/**
 * @function
 * @description Define Page Designer Swiper instances
 */
function initPDSwiper() {
    if ($('.js-pd-slider').length > 0) {
        let pdSliders = document.querySelectorAll('.js-pd-slider');

        pdSliders.forEach(function (element, i) {
            let pdSwiperConfig = JSON.parse(element.getAttribute('data-swiper'));

            element.setAttribute('id', 'pd-swiper-' + i);

            let $nextEl = '#pd-swiper-' + i + ' > .swiper-navigation .swiper-button-next';
            let $prevEl = '#pd-swiper-' + i + ' > .swiper-navigation .swiper-button-prev';
            let $pagination = '#pd-swiper-' + i + ' > .swiper-pagination';

            let additionalConfig = {
                modules: [Navigation, Pagination],
                grabCursor: true,
                loopAddBlankSlides: false,
                observeParents: true,
                observer: true,
                touchMoveStopPropagation: true,
                navigation: {
                    nextEl: $nextEl,
                    prevEl: $prevEl
                },
                pagination: {
                    el: $pagination
                }
            };

            // Combine properties
            pdSwiperConfig = Object.assign({}, pdSwiperConfig, additionalConfig);

            let pdSwiper = new Swiper(element, pdSwiperConfig);
        });
    }
}

/**
 * @function
 * @description Define Page Designer Product Carousel Swiper instances
 */

function initProductSwiper() {
    if ($('.js-pd-product-carousel').length > 0) {
        let pdSliders = document.querySelectorAll('.js-pd-product-carousel');

        pdSliders.forEach(function (element, i) {
            element.setAttribute('id', 'product-swiper-' + i);

            let $nextEl = '#product-swiper-' + i + ' > .swiper-navigation .swiper-button-next';
            let $prevEl = '#product-swiper-' + i + ' > .swiper-navigation .swiper-button-prev';
            let $pagination = '#product-swiper-' + i + ' > .swiper-pagination';

            let productSwiperConfig = {
                modules: [Navigation, Pagination],
                grabCursor: true,
                observeParents: true,
                observer: true,
                touchMoveStopPropagation: true,
                centeredSlides: false,
                loop: true,
                loopAddBlankSlides: false,
                slidesPerView: 2,
                navigation: {
                    nextEl: $nextEl,
                    prevEl: $prevEl,
                },
                pagination: {
                    el: $pagination
                },
                breakpoints: {
                    768: {
                        centeredSlides: false,
                        slidesPerView: 3,
                        // slidesPerGroup: 2, Disabled because it breaks loop (+ navigation) in Swiper 11.2
                    },
                    1024: {
                        slidesPerView: 4,
                        // slidesPerGroup: 2, Disabled because it breaks loop (+ navigation) in Swiper 11.2
                    },
                    1280: {
                        slidesPerView: 5,
                        // slidesPerGroup: 2, Disabled because it breaks loop (+ navigation) in Swiper 11.2
                    }
                }
            }

            let productSwiper = new Swiper(element, productSwiperConfig);
        });
    }
}

/**
 * @function
 * @description Define Page Designer landing page Swiper instances
 */
function initLandingSwiper() {
    if ($('.js-landing-slider').length > 0) {
        let landingSliders = document.querySelectorAll('.js-landing-slider');

        landingSliders.forEach(function (element) {
            let instructions = element.querySelector('.instruction-slide__container');

            let landingSwiperConfig = new Swiper(element, {
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                on: {
                    init: function () {
                        // Add empty slide to offset
                        const emptySlide = document.createElement('div');
                        emptySlide.classList.add('js-landing-carousel-item', 'swiper-slide');
                        this.slides[0].parentNode.insertBefore(emptySlide, this.slides[0]);

                        this.update();
                    },
                    slideChangeTransitionEnd: function () {
                        // Hide instructions after swiping
                        if (this.activeIndex === 1) {
                            if (instructions) {
                                instructions.classList.add('hidden');
                            }
                        }
                    },
                    slideChangeTransitionStart: function () {
                        // Show instructions after swiping back
                        if (this.activeIndex === 0) {
                            if (instructions) {
                                instructions.classList.remove('hidden');
                            }
                        }
                    }
                }
            });
        });
    }
}

/**
 * @function
 * @description Define Recommended Products Swiper instances
 */
function initRecommendedSwiper() {
    if ($('.js-recomm-slider').length > 0) {
        let productSliders = document.querySelectorAll('.js-recomm-slider');

        productSliders.forEach(function (element, i) {
            element.setAttribute('id', 'recommender-swiper-' + i);

            let $nextEl =  '#recommender-swiper-' + i + ' > .swiper-navigation .swiper-button-next';
            let $prevEl = '#recommender-swiper-' + i + ' > .swiper-navigation .swiper-button-prev';
            let $scrollBar = '#recommender-swiper-' + i + ' > .swiper-scrollbar-container .swiper-scrollbar';

            let productSwiper = new Swiper(element, {
                modules: [Navigation, Scrollbar],
                grabCursor: true,
                observeParents: true,
                observer: true,
                touchMoveStopPropagation: true,
                slidesPerView: 2,
                slidesPerGroup: 1,
                navigation: {
                    nextEl: $nextEl,
                    prevEl: $prevEl
                },
                scrollbar: {
                    el: $scrollBar,
                    draggable: true,
                    hide: false
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 3
                    },
                    1024: {
                        slidesPerView: 4,
                        slidesPerGroup: 4
                    },
                    1280: {
                        slidesPerView: 5,
                        slidesPerGroup: 5
                    }
                }
            });
        });
    }
}

/**
 * @function
 * @description Generates the random number.
 * @returns {number} - The random integer number.
 */
function getRandomNumber() {
    return Math.floor(Math.random() * Date.now());
}

/**
 * @function
 * @description Initializes the product tile attributes swiper for a particular element.
 * @param {Element} element - The DOM element to initialize.
 */
function initTileAttrSwiper(element) {
    const i = getRandomNumber();

    element.setAttribute('id', 'attr-swiper-' + i);

    let $nextEl = '#attr-swiper-' + i + ' + .swiper-navigation .swiper-button-next';
    let $prevEl = '#attr-swiper-' + i + ' + .swiper-navigation .swiper-button-prev';

    let tileAttrSwiper = new Swiper(element, {
        modules: [Navigation],
        loop: false,
        centerInsufficientSlides: false,
        grabCursor: true,
        slidesPerView: 'auto',
        slidesPerGroup: 3,
        observeParents: true,
        observer: true,
        touchMoveStopPropagation: true,
        nested: true,
        navigation: {
            nextEl: $nextEl,
            prevEl: $prevEl
        }
    });

    // Set no-swiping class to container if there is nothing to swipe, to remove the padding
    if ($($nextEl).hasClass('swiper-button-lock') && $($prevEl).hasClass('swiper-button-lock')) {
        $('#attr-swiper-' + i).closest('.product-attributes__container').addClass('no-swiping');
    }

    element.dataset.isSwiperInitialized = true; // eslint-disable-line no-param-reassign
}

/**
 * @function
 * @description Initializes the product tile images swiper for a particular element.
 * @param {Element} element - The DOM element to initialize.
 */
function initTileImagesSwiper(element) {
    const i = getRandomNumber();

    element.setAttribute('id', 'tile-img-swiper-' + i);

    let $nextEl = '#tile-img-swiper-' + i + ' > .swiper-navigation .swiper-button-next';
    let $prevEl = '#tile-img-swiper-' + i + ' > .swiper-navigation .swiper-button-prev';
    let $scrollBar = '#tile-img-swiper-' + i + ' > .swiper-scrollbar-container .swiper-scrollbar';

    let tileImagesSwiper = new Swiper(element, {
        modules: [Navigation, Scrollbar],
        loop: true,
        grabCursor: true,
        scrollbar: {
            el: $scrollBar,
            draggable: false,
            hide: false
        },
        breakpoints: {
            1200: {
                navigation: {
                    nextEl: $nextEl,
                    prevEl: $prevEl
                }
            }
        }
    });

    element.dataset.isSwiperInitialized = true; // eslint-disable-line no-param-reassign
}

const productTileObserverOptions = {
    root: null,
    threshold: 0.1
};

const productTileObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            const $tileImagesSlider = $(entry.target).find('.js-tile-images-slider');

            $tileImagesSlider.each(function (i, tileImagesSlider) {
                if (tileImagesSlider.dataset.isSwiperInitialized !== 'true') {
                    initTileImagesSwiper(tileImagesSlider);
                }
            });

            const $tileAttrSlider = $(entry.target).find('.js-tile-attr-slider');

            $tileAttrSlider.each(function (i, tileAttrSlider) {
                if (tileAttrSlider.dataset.isSwiperInitialized !== 'true') {
                    initTileAttrSwiper(tileAttrSlider);
                }
            });

            observer.unobserve(entry.target);
            entry.target.dataset.isObserved = false; // eslint-disable-line no-param-reassign
        }
    });
}, productTileObserverOptions);

/**
 * @function
 * @description Iterates through all available product tiles on the page and binds the IntersectionObserver for each product tile.
 */
function initProductTileSwiper() {
    $('.js-product').each(function (i, productTile) {
        if (productTile.dataset.isObserved !== 'true') {
            productTileObserver.observe(productTile);
            productTile.dataset.isObserved = true; // eslint-disable-line no-param-reassign
        }
    });
}

/**
 * @function
 * @description Initializes all required swipers.
 */
function init() {
    initPDSwiper();
    initProductSwiper();
    initLandingSwiper();
    initRecommendedSwiper();
    initProductTileSwiper();
}

export {
    init,
    initRecommendedSwiper,
    initProductTileSwiper
};
